<p-toast></p-toast>
<p-confirmDialog
  key="apiTokenConfirm"
  [style]="{ width: '30vw' }"
  [baseZIndex]="10000"
></p-confirmDialog>

<div
  class="flex flex-column justify-content-center align-items-center px-2 py-5"
>
  <div class="w-11">
    @if (maintenanceMode) {
      <qa-maintenance-mode
        [action]="userData ? 'update your data' : 'sign up'"
      />
    }

    @if (!maintenanceMode) {
      <div>
        @if (!userData) {
          <h1 class="text-center mb-4">Sign up</h1>
        }
        @if (userData) {
          <h1 class="text-center mb-4">User profile</h1>
        }
        <p-panel>
          <form
            [formGroup]="userForm"
            (ngSubmit)="onSubmit()"
            class="p-fluid flex flex-column gap-5"
          >
            <!-- Username -->
            <div class="mt-4">
              <p-floatLabel>
                <input
                  pInputText
                  id="username"
                  formControlName="username"
                  class="w-full"
                  type="text"
                  autocomplete="username"
                  [ngClass]="{ 'ng-invalid ng-dirty': formErrors?.username }"
                />
                <label for="username">Username</label>
              </p-floatLabel>
              <small class="text-muted">
                Required. 150 characters or fewer. Letters, digits and @/./+/-/_
                only.
              </small>
              @if (formErrors && formErrors.username) {
                <div class="mt-1">
                  @for (error of formErrors.username; track error) {
                    <small class="error-message"
                      >{{ error.message }}<br
                    /></small>
                  }
                </div>
              }
            </div>
            <!-- Password -->
            @if (!userForm.controls["password1"].disabled) {
              <div>
                <p-floatLabel>
                  <input
                    pInputText
                    id="password"
                    formControlName="password1"
                    class="w-full"
                    type="password"
                    autocomplete="new-password"
                    [ngClass]="{ 'ng-invalid ng-dirty': formErrors?.password1 }"
                  />
                  <label for="password">Password</label>
                </p-floatLabel>
                <small class="text-muted">
                  At least 8 characters. Cannot be entirely numeric or too
                  common.
                </small>
                @if (formErrors && formErrors.password1) {
                  <div class="alert mt-1">
                    @for (error of formErrors.password1; track error) {
                      <small class="error-message"
                        >{{ error.message }}<br
                      /></small>
                    }
                  </div>
                }
              </div>
            }
            <!-- Password confirmation -->
            @if (!userForm.controls["password2"].disabled) {
              <div>
                <p-floatLabel>
                  <input
                    pInputText
                    id="password-confirm"
                    formControlName="password2"
                    class="w-full"
                    type="password"
                    [ngClass]="{ 'ng-invalid ng-dirty': formErrors?.password2 }"
                  />
                  <label for="password-confirm">Password confirmation</label>
                </p-floatLabel>
                <small class="text-muted"
                  >Enter the same password as before, for verification.</small
                >
                @if (formErrors && formErrors.password2) {
                  <div class="alert mt-1">
                    @for (error of formErrors.password2; track error) {
                      <small class="error-message"
                        >{{ error.message }}<br
                      /></small>
                    }
                  </div>
                }
              </div>
            }
            <!-- Email -->
            <div>
              <p-floatLabel>
                <input
                  pInputText
                  id="email"
                  formControlName="email"
                  class="w-full"
                  type="email"
                  autocomplete="email"
                  [ngClass]="{ 'ng-invalid ng-dirty': formErrors?.email }"
                />
                <label for="email">Email address</label>
              </p-floatLabel>
              <small class="text-muted"
                >Required. You will receive validation notifications
                here.</small
              >
              @if (formErrors && formErrors.email) {
                <div class="alert mt-1">
                  @for (error of formErrors.email; track error) {
                    <small class="error-message"
                      >{{ error.message }}<br
                    /></small>
                  }
                </div>
              }
            </div>
            <!-- First name -->
            <p-floatLabel>
              <input
                pInputText
                id="first-name"
                formControlName="first_name"
                class="w-full"
                type="text"
              />
              <label for="first-name"
                >First name <span class="text-muted">(optional)</span></label
              >
            </p-floatLabel>
            <!-- Last name -->
            <p-floatLabel>
              <input
                pInputText
                id="last-name"
                formControlName="last_name"
                class="w-full"
                type="text"
              />
              <label for="last-name"
                >Last name <span class="text-muted">(optional)</span></label
              >
            </p-floatLabel>
            <!-- Organisation -->
            <p-floatLabel>
              <input
                pInputText
                id="organisation"
                formControlName="organisation"
                class="w-full"
                type="text"
              />
              <label for="organisation"
                >Organisation <span class="text-muted">(optional)</span></label
              >
            </p-floatLabel>
            <!-- Country -->
            <p-floatLabel class="w-full">
              <p-select
                inputId="selectCountry"
                [options]="countries$ | async"
                styleClass="w-full"
                [style]="{ width: '100%', height: '2.5rem' }"
                formControlName="country"
                optionLabel="name"
                optionValue="code"
                placeholder=" "
                ngDefaultControl
              >
              </p-select>
              <label for="selectCountry"
                >Country <span class="text-muted">(optional)</span></label
              >
            </p-floatLabel>
            <!-- ORCID -->
            <div>
              <p-floatLabel>
                <input
                  pInputText
                  id="orcid"
                  formControlName="orcid"
                  class="w-full"
                  type="text"
                  [ngClass]="{ 'ng-invalid ng-dirty': formErrors?.orcid }"
                />
                <label for="orcid"
                  >ORCID <span class="text-muted">(optional)</span></label
                >
              </p-floatLabel>
              <small class="text-muted">
                e.g. 0000-0002-1825-0097 — used to identify you as author when
                publishing to Zenodo.
              </small>
              @if (formErrors && formErrors.orcid) {
                <div class="alert mt-1">
                  @for (error of formErrors.orcid; track error) {
                    <small class="error-message"
                      >{{ error.message }}<br
                    /></small>
                  }
                </div>
              }
            </div>
            <!-- Terms -->
            @if (!userData) {
              <div class="flex align-items-center gap-2">
                <p-checkbox
                  id="terms"
                  formControlName="terms_consent"
                  [binary]="true"
                ></p-checkbox>
                <label for="terms" class="cursor-pointer">
                  I accept the
                  <a [routerLink]="['/terms']" target="_blank"
                    >terms, conditions and privacy policy</a
                  >.
                </label>
              </div>
            }
            <!-- Honeypot -->
            @if (!userData) {
              <div class="flex flex-column gap-2">
                <label for="honeypot-user" class="text-muted text-sm">
                  <i class="pi pi-shield mr-2"></i>
                  Are you a real person? Slide the handle all the way to the
                  right
                  <i class="pi pi-angle-double-right ml-1"></i>
                </label>
                <p-slider
                  id="honeypot-user"
                  formControlName="honeypot"
                ></p-slider>
              </div>
            }
            <!-- Submit -->
            <div class="flex justify-content-center">
              @if (!userData) {
                <button
                  pButton
                  type="submit"
                  label="Sign up"
                  class="w-6"
                  [disabled]="!userForm.valid"
                ></button>
              }
              @if (userData) {
                <button
                  pButton
                  type="submit"
                  label="Save changes"
                  class="w-6"
                ></button>
              }
            </div>
          </form>
        </p-panel>
        <!-- API Token & Account actions (only for existing users) -->
        @if (userData) {
          <div class="flex flex-column gap-3 mt-4">
            <p-panel header="API Token">
              <div class="flex flex-column gap-3 pt-4">
                <p-floatLabel>
                  <input
                    #tokenInput
                    pInputText
                    id="api-token"
                    class="w-full"
                    type="text"
                    [value]="apiToken || 'No token assigned'"
                    readonly
                  />
                  <label for="api-token">
                    <i class="pi pi-key mr-2"></i>API Token
                  </label>
                </p-floatLabel>
                <div class="flex justify-content-center gap-2">
                  <button
                    pButton
                    type="button"
                    label="Request API token"
                    class="w-6"
                    (click)="confirmRequestToken()"
                    pTooltip="Request a unique API token for submitting validations via public API"
                  ></button>
                  @if (hasToken()) {
                    <button
                      pButton
                      type="button"
                      icon="pi pi-copy"
                      class="p-button-secondary"
                      (click)="copyToken(tokenInput)"
                      pTooltip="Copy token to clipboard"
                    ></button>
                  }
                </div>
              </div>
            </p-panel>
            <p-panel header="Account">
              <div class="flex flex-column align-items-center gap-2 pt-2">
                <button
                  pButton
                  type="button"
                  label="Update password"
                  class="w-6"
                  (click)="redirectToSetPassword()"
                ></button>
                <button
                  pButton
                  type="button"
                  label="Deactivate my account"
                  class="p-button-danger w-6"
                  (click)="deactivateAccount()"
                ></button>
              </div>
            </p-panel>
          </div>
        }
      </div>
    }
  </div>
</div>
